module.exports = "/_next/static/images/spaceship-super_money-mag-badge-a47a1f4644e00e92b813986018ab829a.svg";